import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

interface RoundLinkProps {
  children: React.ReactNode
  href: string
  className?: string
}

export const RoundLink: React.FC<RoundLinkProps> = (props) => {
  const { href, className, children } = props
  return (
    <Link
      to={href}
      className={classNames(
        'bg-white text-brand-6 rounded-full w-11 h-11 p-0 overflow-hidden flex justify-center content-center fill-current',
        className
      )}
    >
      {children}
    </Link>
  )
}
